import api from "../../../api"

export function manageTags(page){
    return api.get(`cms/tags?pageSize=10&pageNumber=${page}`);
}

export function tagOrder(){
    return api.get("cms/tags/order");
}

export function postTag(payload){
    return api.post('cms/tags', payload);
}

export function tagContent(id){
    return api.get(`cms/tags/${id}/tag-contents`)
}

export function activeStatus(id, activeStatus){
    return api.put(`cms/tags/${id}/status?isActive=${activeStatus}`)
}

export function deleteTag(id){
    return api.delete(`cms/tags/${id}`)
}